// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ultimate-security-topbar .topbar-left {
  gap: 14px;
}
.ultimate-security-topbar .topbar-left .dashboard-link {
  margin-left: 20px;
}
.ultimate-security-topbar .topbar-left li {
  list-style-type: none;
}
.ultimate-security-topbar .topbar-left li a {
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}
.ultimate-security-topbar .topbar-left li a:focus {
  box-shadow: unset;
  outline: unset;
}
.ultimate-security-topbar .topbar-right .header-logos {
  padding-right: 16px;
}
.ultimate-security-topbar .topbar-right .header-logos a:focus {
  box-shadow: unset;
  outline: unset;
}
.ultimate-security-topbar .topbar-right .topbar-right-unit {
  display: flex;
  align-items: center;
}
.ultimate-security-topbar .topbar-right .topbar-right-unit:not(:first-child)::before {
  content: "";
  width: 2px;
  height: 20px;
  background-color: rgba(255, 255, 255, 0.5);
  display: block;
  margin-left: 18px;
  margin-right: 18px;
}

.search-box-wrapper {
  position: relative;
  padding: 0px;
}
.search-box-wrapper .search-input-wrapper {
  padding: 16px 18px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.search-box-wrapper .search-input-wrapper input[type=text] {
  padding: 0.5rem;
  width: 100%;
  border-style: none;
  box-shadow: none;
}
.search-box-wrapper .nav-search-output {
  max-height: 256px;
  overflow-y: auto;
  border-top: 1px solid rgb(216, 217, 219);
  padding: 4px 6px;
}
.search-box-wrapper .nav-search-output a {
  display: block;
  text-decoration: none;
  border-radius: 6px;
  color: #000000;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 1%;
  margin-bottom: 8px;
  padding: 8px 16px;
  position: relative;
}
.search-box-wrapper .nav-search-output a strong {
  color: #2C045D;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 1%;
}
.search-box-wrapper .nav-search-output a::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  width: 3px;
  height: 20px;
  border-radius: 2px;
  transform: translateY(-50%);
}
.search-box-wrapper .nav-search-output a:hover {
  background-color: #F3F3F8;
}
.search-box-wrapper .nav-search-output a:hover::before {
  background-color: #873EFF;
}`, "",{"version":3,"sources":["webpack://./src/layouts/Header/Header.scss"],"names":[],"mappings":"AACC;EACC,SAAA;AAAF;AACQ;EACI,iBAAA;AACZ;AACE;EACC,qBAAA;AACH;AAAG;EACa,aAAA;EACA,mBAAA;EACA,QAAA;EACA,qBAAA;EACZ,WAAA;EACA,eAAA;EACY,gBAAA;EACZ,iBAAA;AAEJ;AAAI;EACC,iBAAA;EACA,cAAA;AAEL;AAIE;EACC,mBAAA;AAFH;AAII;EACC,iBAAA;EACA,cAAA;AAFL;AAOE;EACC,aAAA;EACA,mBAAA;AALH;AAOG;EACC,WAAA;EACA,UAAA;EACA,YAAA;EACA,0CAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AALJ;;AAWA;EACC,kBAAA;EACG,YAAA;AARJ;AASC;EACC,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAPF;AAQE;EACC,eAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AANH;AASC;EACC,iBAAA;EACA,gBAAA;EACA,wCAAA;EACA,gBAAA;AAPF;AAQE;EACC,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AANH;AAOG;EACC,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AALJ;AAOG;EACC,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;AALJ;AAOG;EACC,yBAAA;AALJ;AAMI;EACC,yBAAA;AAJL","sourcesContent":[".ultimate-security-topbar {\n\t.topbar-left {\n\t\tgap: 14px;\n        .dashboard-link{\n            margin-left: 20px;\n        }\n\t\tli {\n\t\t\tlist-style-type: none;\n\t\t\ta {\n                display: flex;\n                align-items: center;\n                gap: 8px;\n                text-decoration: none;\n\t\t\t\tcolor: #fff;\n\t\t\t\tfont-size: 16px;\n                font-weight: 600;\n\t\t\t\tline-height: 24px;\n\t\t\t\t\n\t\t\t\t&:focus{\n\t\t\t\t\tbox-shadow: unset;\n\t\t\t\t\toutline: unset;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.topbar-right {\n\t\t.header-logos {\n\t\t\tpadding-right: 16px;\n\t\t\ta{\n\t\t\t\t&:focus{\n\t\t\t\t\tbox-shadow: unset;\n\t\t\t\t\toutline: unset;\n\t\t\t\t}\n\t\t\t}\n\t\t\t\t\n\t\t}\n\t\t.topbar-right-unit {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\n\t\t\t&:not(:first-child)::before {\n\t\t\t\tcontent: \"\";\n\t\t\t\twidth: 2px;\n\t\t\t\theight: 20px;\n\t\t\t\tbackground-color: rgba(255, 255, 255, 0.5);\n\t\t\t\tdisplay: block;\n\t\t\t\tmargin-left: 18px;\n\t\t\t\tmargin-right: 18px;\n\t\t\t}\n\t\t}\n\t}\n\t\n}\n.search-box-wrapper {\n\tposition: relative;\n    padding: 0px;\n\t.search-input-wrapper {\n\t\tpadding: 16px 18px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 12px;\n\t\tinput[type=text] {\n\t\t\tpadding: 0.5rem;\n\t\t\twidth: 100%;\n\t\t\tborder-style: none;\n\t\t\tbox-shadow: none;\n\t\t}\n\t}\n\t.nav-search-output {\n\t\tmax-height: 256px;\n\t\toverflow-y: auto;\n\t\tborder-top: 1px solid rgb(216, 217, 219);\n\t\tpadding: 4px 6px;\n\t\ta {\n\t\t\tdisplay: block;\n\t\t\ttext-decoration: none;\n\t\t\tborder-radius: 6px;\n\t\t\tcolor: #000000;\n\t\t\tfont-weight: 400;\n\t\t\tfont-size: 12px;\n\t\t\tline-height: 16px;\n\t\t\tletter-spacing: 1%;\n\t\t\tmargin-bottom: 8px;\n\t\t\tpadding: 8px 16px;\n\t\t\tposition: relative;\n\t\t\tstrong {\n\t\t\t\tcolor: #2C045D;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tline-height: 20px;\n\t\t\t\tletter-spacing: 1%;\n\t\t\t}\n\t\t\t&::before {\n\t\t\t\tcontent: '';\n\t\t\t\tposition: absolute;\n\t\t\t\tleft: 0;\n\t\t\t\ttop: 50%;\n\t\t\t\twidth: 3px;\n\t\t\t\theight: 20px;\n\t\t\t\tborder-radius: 2px;\n\t\t\t\ttransform: translateY(-50%);\n\t\t\t}\n\t\t\t&:hover {\n\t\t\t\tbackground-color: #F3F3F8;\n\t\t\t\t&::before {\n\t\t\t\t\tbackground-color: #873EFF;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
